import { rankList, trendingTopics } from '@/mocks/homeData';

function DeltaBadge({ delta }: { delta: string }) {
  if (delta === '0') {
    return <span className="inline-flex items-center text-xs text-foreground-400 whitespace-nowrap">持平</span>;
  }
  const up = delta.startsWith('+');
  return (
    <span className={`inline-flex items-center gap-0.5 text-xs whitespace-nowrap ${up ? 'text-primary-500' : 'text-foreground-500'}`}>
      <i className={`${up ? 'ri-arrow-up-line' : 'ri-arrow-down-line'}`}></i>
      {delta.slice(1)}
    </span>
  );
}

function RankRow({ item, rank }: { item: (typeof rankList)[number]; rank: number }) {
  return (
    <a
      href="#flash"
      className="group flex items-center gap-3 md:gap-4 border-b border-background-200/70 px-3 py-3 transition-colors last:border-0 hover:bg-background-100/70"
    >
      <span
        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-black ${
          rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
        }`}
      >
        {String(rank).padStart(2, '0')}
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600">{item.title}</h3>
        </div>
        <span className="text-xs text-foreground-400">{item.tag} · 热度 {(item.heat / 10000).toFixed(1)}w</span>
      </div>
      <DeltaBadge delta={item.delta} />
      {rank === 1 && <i className="ri-fire-fill text-primary-500"></i>}
    </a>
  );
}

export default function RankTopics() {
  return (
    <section id="rank" className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
        {/* 左侧：热度榜单 */}
        <div className="lg:col-span-7 flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="flex items-center justify-between border-b border-background-200 bg-foreground-950 px-5 py-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-bar-chart-2-fill text-lg"></i>
              </span>
              <div>
                <h2 className="font-heading text-lg font-black text-background-50">今日热度飙升榜</h2>
                <p className="text-[11px] text-background-300">实时刷新 · 越靠前越火</p>
              </div>
            </div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-fire-fill"></i> TOP10
            </span>
          </div>
          <div className="flex-1 divide-y-0 px-2 py-1">
            {rankList.map((item, i) => (
              <RankRow key={i} item={item} rank={i + 1} />
            ))}
          </div>
        </div>

        {/* 右侧：话题墙 */}
        <div className="lg:col-span-5 flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="flex items-center gap-2.5 border-b border-background-200 bg-secondary-100 px-5 py-4">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-hashtag text-lg"></i>
            </span>
            <div>
              <h2 className="font-heading text-lg font-black text-foreground-950">热议话题墙</h2>
              <p className="text-[11px] text-foreground-500">随手点一个，直接进瓜田</p>
            </div>
          </div>
          <div className="flex flex-wrap gap-2.5 p-5">
            {trendingTopics.map((t, i) => (
              <a
                key={i}
                href="#topics"
                className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-[13px] font-medium transition-colors ${
                  i < 3
                    ? 'border-primary-200 bg-primary-50 text-primary-700 hover:bg-primary-100'
                    : 'border-background-200 bg-background-100/60 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                <i className="ri-hashtag text-[11px] opacity-70"></i>
                {t.name}
                <span className="text-xs opacity-60">·{t.count}</span>
              </a>
            ))}
          </div>
          <div className="mt-auto flex items-center justify-between gap-3 rounded-lg bg-accent-100/80 m-5 mb-5 px-4 py-3">
            <p className="text-xs leading-relaxed text-accent-900">
              <b>还没看够？</b>每日本站手动整理打包资源与图文视频切片，想看的内容一次看个够。
            </p>
            <a href="#packs" className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-3 py-2 text-xs font-semibold text-background-50 hover:bg-accent-600">
              打包合集 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}